import api from '@/api'

const namespaced = true

const state = {
  fuelSupplyTugboats: [],
  routes: [],
  fuelSupplyTugboatsFiles: {}
}

const getters = {
  fuelSupplyTugboats: state => state.fuelSupplyTugboats,
  routes: state => state.routes,
  fuelSupplyTugboatsFiles: state => state.fuelSupplyTugboatsFiles
}

const mutations = {
  SET_FUEL_SUPPLY_TUGBOATS: (state, payload) => {
    state.fuelSupplyTugboats = payload
  },
  SET_ROUTES: (state, payload) => {
    state.routes = payload
  },
  SET_FUEL_SUPPLY_TUGBOATS_FILES: (state, payload) => {
    state.fuelSupplyTugboatsFiles = payload
  }
}

const actions = {
  async fetchFuelSupplyTugboats({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage || 1,
        limit: filterConfig.pageSize || 10,
        ...payload
      }
      const { data } = await api.getFuelSupplyTugboats(filter)
    
      if (data.error) {
        commit('SET_FUEL_SUPPLY_TUGBOATS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }
    
      commit('SET_FUEL_SUPPLY_TUGBOATS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async postFuelSupplyTugboat({}, payload) {
    try {
      await api.postFuelSupplyTugboat(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async putFuelSupplyTugboat({}, payload) {
    try {
      await api.putFuelSupplyTugboat(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async deleteFuelSupplyTugboat({}, payload) {
    try {
      await api.deleteFuelSupplyTugboat(payload)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getRoutes()
      if (data.error) {
        commit('SET_ROUTES', [])
        return
      }

      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  },
  async getDeletedFuelSupplyTugboatByRouteName({}, route_name) {
    try {
      const data = await api.getFuelSupplyTugboats({
        is_get_deleted: true,
        route_name: route_name
      })
      return data
    } catch ({ data }) {
      throw data
    }
  },
  async downloadFuelSupplyTugboats({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getFuelSupplyTugboatsExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_FUEL_SUPPLY_TUGBOATS_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetFuelSupplyTugboatsFiles({ commit }) {
    commit('SET_FUEL_SUPPLY_TUGBOATS_FILES', {})
  },
  async fetchRoutesWithType({ commit }, payload) {
    try {
      const { data } = await api.getRoutes(payload)
      if (data.error) {
        commit('SET_ROUTES', [])
        return
      }

      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchAllFuelSupplyTugboats({ commit }, payload) {
    try {
      const data  = await api.getFuelSupplyTugboats(payload)

      if (data.error) {
        commit('SET_FUEL_SUPPLY_TUGBOATS', [])
        return
      }

      commit('SET_FUEL_SUPPLY_TUGBOATS', data.data)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }